import React, { Fragment } from 'react'
import PagesHeading from '../pages-heding/PagesHeading'
import ResearchCell from '../research-cell/ResearchCell'

const ResearchCellPage = (props) => {
  return (
    <Fragment>
        <PagesHeading page_title={props.page_title}></PagesHeading>
        <ResearchCell></ResearchCell>
    </Fragment>
  )
}

export default ResearchCellPage